import { Link } from "react-router";
import { errorMessage } from "../../api/client";
import { useBootstrapQuery, usePropertiesQuery } from "../../api/queries";
import { DirectoryList } from "../../ui/DirectoryList";
import { useTestPrices } from "../../ui/testPrices";
import { DirectoryMyStores } from "../../ui/VisitorAccess";
import { PageShell } from "../../ui/PageShell";
import { DirectoryRealEstate } from "../../ui/realEstate/DirectoryRealEstate";
import { DirectoryHomes } from "../../ui/homes/DirectoryHomes";
import { DirectoryTasks } from "../../ui/rewards/EarnCoins";

/** `/directory`: the accessible HTML list with the same actions as the world (docs/01 section 7). */
export function DirectoryPage() {
  useBootstrapQuery();
  const q = usePropertiesQuery(true);
  const testPrices = useTestPrices();
  return (
    <PageShell title="Directory">
      <p className="muted">
        Every business and plot in Townsy, with the same actions as the 3D town. Website links open in a new tab only when you click
        them.{testPrices ? " Prices are development test values." : ""}{" "}
        <Link to="/">Back to the town</Link>.
      </p>
      <nav className="row small" aria-label="Townsy shops on this page" style={{ marginBottom: 12 }}>
        <span className="muted">Jump to:</span>
        <a href="#tasks">Sponsored tasks</a>
        <a href="#real-estate">Townsy Real Estate</a>
        <a href="#home-builders">Townsy Home Builders</a>
        <a href="#furnishings">Townsy Furnishings</a>
        <a href="#my-home">My home</a>
      </nav>
      {q.isPending ? (
        <p className="muted">Loading listings…</p>
      ) : q.error ? (
        <div className="notice notice-danger" role="alert">
          <strong>Couldn't load the directory.</strong> {errorMessage(q.error)}{" "}
          <button type="button" className="btn btn-sm" onClick={() => void q.refetch()}>
            Retry
          </button>
        </div>
      ) : (
        <>
          <DirectoryList items={q.data.items} />
          <DirectoryMyStores items={q.data.items} />
        </>
      )}
      <DirectoryTasks />
      <DirectoryRealEstate />
      <DirectoryHomes />
    </PageShell>
  );
}
